import React from 'react';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import './UserStats.css';

export default function UserStats({ stats }) {
  return (
    <div className="user-stats">
      <div className="stat-card">
        <div className="stat-icon">
          <WaterDropRoundedIcon />
        </div>
        <div className="stat-info">
          <h3>Consumo Mensual</h3>
          <p>{stats.monthlyConsumption} litros</p>
        </div>
      </div>
      
      <div className="stat-card">
        <div className="stat-icon">
          <ShowChartRoundedIcon />
        </div>
        <div className="stat-info">
          <h3>Ahorro</h3>
          <p>{stats.savings}%</p>
        </div>
      </div>
      
      <div className="stat-card">
        <div className="stat-icon">
          <CalendarMonthRoundedIcon />
        </div>
        <div className="stat-info">
          <h3>Días Monitoreados</h3>
          <p>{stats.monitoredDays} días</p>
        </div>
      </div>
    </div>
  );
} 